var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.$t('likes.seeOnlyMyCoinsTitle')))]),_c('v-checkbox',{staticClass:"mt-1",attrs:{"label":_vm.$t('likes.seeOnlyMyCoins'),"hide-details":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }